import { ContactModel, ContactResultModel } from './contact.model';

export class ContactSearchResultModel {
	contacts: ContactResultModel[];
	pageSize: number;
	pageNumber: number;
	resultCount: number;
}